import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

interface Breadcrumb {
  label: string;
  url: string;
}

interface NavigationPage { title: string; link: string; }

@Component({
  selector: 'app-assurance-multirisque-pro',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './assurance-multirisque-pro.component.html',
  styleUrls: ['./assurance-multirisque-pro.component.scss']
})
export class AssuranceMultirisqueProComponent {
  title = 'Assurance Multirisque Professionnelle';
  subtitle = '';
  heroImage = 'assets/static_pages_images/bar.jpg';

  breadcrumbs = [
    { label: 'Entreprises', link: undefined },
    { label: 'Assurance Multirisque Professionnelle', link: undefined }
  ];

  prevPage = { 
    title: 'Assurance Flotte Moto Professionnelle',
    link: '/assurance-flotte-moto-professionnelle'
  };

  nextPage = { 
    title: 'Assurance Multirisque Immeuble - MAI - PNE',
    link: '/assurance-multirisque-immeuble-pro'
  };

  partners = [
    { name: 'GENERALI', logo: 'assets/partners/generali.png' },
    { name: 'AXA', logo: 'assets/partners/axa.png' },
    { name: 'PROGEAS', logo: 'assets/partners/progeas.png' },
    { name: 'SOLLY AZAR', logo: 'assets/partners/solly-azar.png' },
    { name: 'SURAVENIR', logo: 'assets/partners/suravenir.png' },
    { name: 'HELVETIA', logo: 'assets/partners/helvetia.png' },
    { name: 'TETRIS ALLIANZ', logo: 'assets/partners/tetris-allianz.png' }
  ];
}
